import { apiClient } from '@/services/ApiClient.js'

export default {
  sendFarmerVerificationDocument(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('farmers/' + form.farmerId + '/documents', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateFarmerDocumentStatus(farmerId, documentId, payload) {
    return apiClient
      .patch('farmers/' + farmerId + '/documents/' + documentId, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDocument(farmerId, documentId) {
    return apiClient
      .get('farmers/' + farmerId + '/documents/' + documentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDocuments(farmerId, query) {
    return apiClient
      .get('farmers/' + farmerId + '/documents', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewDocument(documentId) {
    return apiClient
      .get(`farmers/view-document/${documentId}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  deleteFarmerDocument(farmerId, documentId) {
    return apiClient
      .delete('farmers/' + farmerId + '/documents/' + documentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  listDocuments(farmerId) {
    return apiClient
      .get('farmers/' + farmerId + '/list-documents')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  documentVersions(farmerId, documentId) {
    return apiClient
      .get('farmers/' + farmerId + '/documents/' + documentId + '/versions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateDocumentStatus(farmerId, documentId, payload) {
    return apiClient
      .patch('farmers/' + farmerId + '/documents/' + documentId + '/status', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
